import { render, staticRenderFns } from "./corp-auth-status.vue?vue&type=template&id=49594d8e&scoped=true&"
import script from "./corp-auth-status.vue?vue&type=script&lang=js&"
export * from "./corp-auth-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49594d8e",
  null
  
)

export default component.exports